import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Page } from './page.model'

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnInit {
  @Input() page : Page;
  @Input() numberOfPages = 5;
  @Input() displayPageNumberOffset = 0;
  @Output() go = new EventEmitter<number>();
  @Output() first = new EventEmitter<number>();
  @Output() last = new EventEmitter<number>();
  @Output() next = new EventEmitter<number>();
  @Output() previous = new EventEmitter<number>();


  range = (start:number, end:number) => Array.from({length: (end - start)}, (v, k) => k + start);

  constructor() { }

  ngOnInit() {
  }

  hasPrevious() : boolean {
    return this.page.current > 1;
  }

  hasNext() : boolean {
    return this.page.current < this.page.total / this.page.size;
  }

  getPagesToDisplay(): Array<number>{
    let start = 1;
    const n = Math.ceil(this.page.total/this.page.size)
    if (this.page.current - Math.floor(this.numberOfPages/2)> 0){
      start = this.page.current - Math.floor(this.numberOfPages/2);
    }
    if (start  + this.numberOfPages > n){
      start = Math.max(1, n - this.numberOfPages+1);
    }

    return this.range(start, start+Math.min(n, this.numberOfPages));
  }

  goFirstPage():void{
    this.go.emit(1);
    this.first.emit(1);
  }
  goPreviousPage():void{
    this.go.emit(this.page.current - 1);
    this.previous.emit(this.page.current - 1);
  }
  goPage(pageNumber:number):void{
    this.go.emit(pageNumber);
    if (pageNumber==this.page.current+1){
      this.next.emit(pageNumber);
    } else if (pageNumber == this.page.current-1){
      this.previous.emit(pageNumber);
    }
  }
  goNextPage():void{
    this.go.emit(this.page.current + 1);
    this.next.emit(this.page.current + 1);
  }
  goLastPage():void{
    this.go.emit(this.getLastPage());
    this.last.emit(this.getLastPage());
  }
  getLastPage():number{
    return Math.ceil(this.page.total/this.page.size);
  }
}
